"use client";

import useInfiniteScroll from "../../../hooks/use-infinite-scroll";
import type { ModelsCaseCard, Theme } from "../../../types";
import { MediaCard } from "../../common/media-card";
import { Button } from "../../ui/button";
import { caseListGridVariant } from "./case-list.variants";
import { CaseCard } from "../../common/case-card";

export interface CaseListGridProps {
  theme: Theme;
  moreButtonLabel: string;
  sectionName: string;
  cards: ModelsCaseCard[];
}

function CaseListGrid({ moreButtonLabel, cards }: CaseListGridProps) {
  const styles = caseListGridVariant();
  const items = useInfiniteScroll<ModelsCaseCard>(cards, 6);

  const { loading, hasMoreItems, loadedItems, getMoreItems } = items;

  const [...posts] = loadedItems;

  return (
    <div className={styles.base()}>
      <div className={styles.content()}>
        {posts.map((card) => (
          <div className={styles.card()} key={`case-card-${card.id}`}>
            <CaseCard {...card} />
          </div>
        ))}
      </div>
      {hasMoreItems ? (
        <footer className={styles.footing()}>
          <Button
            appearance="solid"
            color="blue"
            isLoading={loading}
            loadingLabel="Loading"
            onClick={() => {
              getMoreItems();
            }}
          >
            {moreButtonLabel}
          </Button>
        </footer>
      ) : null}
    </div>
  );
}

export default CaseListGrid;
